import { Button } from "@/components/Button"
import { Fragment } from "react/jsx-runtime"

export const RainInfo = () => {
  return (
    <Fragment>
      <h4 className="h4 welcome-info__title text-left">Business Verification</h4>
      <p className="welcome-info__verefy-descr">Your business will be verified using documents issued by a country or authority</p>
      <div className="mt-5">
        <Button variant="contained" color="primary" to="/company-verification/form">
          Get Started
        </Button>
      </div>
    </Fragment>
  )
}
